import { compose } from 'redux';
import { setDisplayName, withProps } from 'recompose';
import { getQuestionConfigLimits } from 'sharedParts/config/blockConfig';
import { questionTypes } from 'sharedParts';
import RatingForm from '../../rating/RatingForm';
import ScaleQuestionFormField from '../ScaleQuestionFormField';
import withScaleRatingItemStyle from '../withScaleRatingItemStyle';

export default compose(
  withProps(({ block: { itemList } }) => ({
    ratingField: ScaleQuestionFormField,
    maxCount: getQuestionConfigLimits(questionTypes.questionScale).itemList.max,
    minCount: getQuestionConfigLimits(questionTypes.questionScale).itemList.min,
    itemListCount: itemList.length,
  })),
  withScaleRatingItemStyle,
  setDisplayName('ScaleQuestionForm'),
)(RatingForm);
